module.exports = __webpack_public_path__ + "media/icon_transaction/dog_1-8137405f.png";